import { render } from "./cotizacion.vue?vue&type=template&id=1713f970"
import script from "./cotizacion.vue?vue&type=script&lang=js"
export * from "./cotizacion.vue?vue&type=script&lang=js"

import "./cotizacion.vue?vue&type=style&index=0&id=1713f970&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__